import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface DividerProps {
    /**
     * Color of the divider line
     * @default outlineInactive
     */
    color?: string;
    /**
     * Margin horizontal to extend beyond parent padding
     * @default -8
     */
    marginHorizontal?: number;
}

/**
 * Simple divider component
 */
export function Divider({
    color,
    marginHorizontal = -8,
}: DividerProps) {
    const colors = useUIColors();
    const dividerColor = color || colors.outlineInactive;

    return (
        <View style={[styles.container, { marginHorizontal }]}>
            <View style={[styles.line, { backgroundColor: dividerColor }]} />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
    },
    line: {
        flex: 1,
        height: 1,
    },
});

